import { attr, Model } from 'redux-orm';
import {
  createAction,
  createAddConst,
  createDeleteConst,
  createRequestConst,
  createUpdateConst,
} from '../util';

export default class RecentPayer extends Model {
  static get modelName() {
    return 'RecentPayer';
  }

  static reducer({ data, type }, RecentPayer) {
    switch (type) {
      case ADD.SUCCESS:
        RecentPayer.filter(({ payerId }) => payerId === data.payerId).delete();
        RecentPayer.create(data);
        break;

      case CLEAR.SUCCESS:
      case CLEAR_LOCATION.SUCCESS:
        RecentPayer.delete();
        break;

      case LOAD.SUCCESS:
        RecentPayer.delete();
        data.forEach((r) => RecentPayer.upsert(r));
        break;

      case REMOVE.SUCCESS:
        RecentPayer.withId(data.id).delete();
        break;

      case UPDATE.SUCCESS:
        RecentPayer.upsert(data);
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      id: attr(),
      fspId: attr(),
      location: attr(),
      ownerType: attr(),
      payerId: attr(),
      payerType: attr(),
      primary: attr(),
      secondary: attr(),
      tertiary: attr(),
    };
  }
}

export const ADD = createAddConst(RecentPayer.modelName);
export const CLEAR = createDeleteConst(`${RecentPayer.modelName}_clear`);
export const CLEAR_LOCATION = createDeleteConst(
  `${RecentPayer.modelName}_clearLocation`
);
export const LOAD = createRequestConst(RecentPayer.modelName);
export const REMOVE = createDeleteConst(RecentPayer.modelName);
export const UPDATE = createUpdateConst(RecentPayer.modelName);

export const add = createAction(ADD);
export const clear = createAction(CLEAR);
export const load = createAction(LOAD);
export const remove = createAction(REMOVE);
export const update = createAction(UPDATE);
